import React, { useEffect, useRef, useState } from "react";
import { Map } from "ol";
import View from "ol/View";
import { OSM, Vector as VectorSource } from "ol/source";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import Draw from "ol/interaction/Draw";
import "ol/ol.css";
import BaseLayer from "ol/layer/Base";
import { fromLonLat, toLonLat } from "ol/proj";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUndo } from "@fortawesome/free-solid-svg-icons";
import Point from "ol/geom/Point";
import { RefreshIcon } from "../../iconSet/IconSet";

export var coordinatesArray: number[][] = [];
const FloodViewSimulationMap = () => {
  const mapRef = useRef<HTMLDivElement>(null);
  const [mapInstance, setMapInstance] = useState<Map | null>(null);
  const [drawInteraction, setDrawInteraction] = useState<Draw | null>(null);
  const [vectorBaseLayer, setVectorBaseLayer] = useState<BaseLayer | undefined>(
    undefined
  );
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    if (!mapInstance && mapRef.current) {
      const rasterLayer = new TileLayer({
        source: new OSM(),
      });

      const source = new VectorSource({ wrapX: false });

      const vectorLayer = new VectorLayer({
        source: source,
      });

      const mapInstance = new Map({
        layers: [rasterLayer, vectorLayer],
        target: mapRef.current,
        controls: [],
        view: new View({
          center: fromLonLat([80.7718, 7.8731]),
          zoom: 7,
        }),
      });
      setMapInstance(mapInstance);
      setVectorBaseLayer(vectorLayer);
      mapInstance.on("click", function (event) {
        const feature = mapInstance.getFeaturesAtPixel(event.pixel)[0];
        if (!feature) {
          return;
        }
        const geometry = feature.getGeometry() as Point;
        const coordinate = geometry.getFlatCoordinates();
        const lon = coordinate[0];
        const lat = coordinate[1];
        coordinatesArray.push([lon, lat]);
      });
      return () => {
        mapInstance.setTarget(undefined);
      };
    }
  }, []);

  useEffect(() => {
    addInteraction();
  }, [vectorBaseLayer]);

  const addInteraction = () => {
    if (vectorBaseLayer instanceof VectorLayer) {
      const draw = new Draw({
        source: vectorBaseLayer.getSource(),
        type: "Polygon",
      });
      mapInstance!.addInteraction(draw);
      setDrawInteraction(draw);
    }
  };

  const handleUndo = () => {
    if (drawInteraction == null) return;
    drawInteraction.removeLastPoint();
    if (mapInstance == null) return;
    if (vectorBaseLayer == null) return;

    if (vectorBaseLayer instanceof VectorLayer) {
      vectorBaseLayer.getSource().clear();
    }
    coordinatesArray = [];
  };
  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div style={{ height: "100%" }} id="map" ref={mapRef}></div>

      <div
        style={{
          width: "100%",
          position: "absolute",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          alignContent: "flex-start",
          top: "0%",
          color: "black",
          fontSize: "14px",
          fontWeight: "600",
          backgroundColor: "rgba(0,0,0,0.3)",
        }}
      >
        Draw your catchment area here
      </div>
      <div
      
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
        style={{
          position: "absolute",
          bottom: "8%",
          right: "5%",
          borderRadius: "50%",
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          alignContent:"center",
          width: "25px",
          height: "25px",
        }}
      >
         <div
          onClick={() => {
            handleUndo();
          }}
          onTouchStart={() => {
            handleUndo();
          }}
          style={{
            borderRadius: "50%",
            width: "15px",
            height: "15px",
            color: "black",
            cursor: "pointer",
          }}>
                 <RefreshIcon
       width="2rem" color="var(--color-text)" 
        />
             </div>
   
      </div>
    </div>
  );
};

export default FloodViewSimulationMap;
